export default __webpack_public_path__ + "static/media/d-verse.5068cdf9.jpg";